import React from 'react';
import { Button, Card, Input, Select, TrashIcon } from '@avila-tek/ui/src';
import { FormHeader } from '../shared/Forms';
import { Region } from '../../models';
import RegionsList from './RegionsList';

interface RegionsInputProps {
  regions: Region[];
  setRegions: React.Dispatch<React.SetStateAction<Region[]>>;
}

function RegionsInput({ regions, setRegions }: RegionsInputProps) {
  const [newRegion, setNewRegion] = React.useState('');
  const [newSubRegion, setNewSubRegion] = React.useState('');
  const [selectedRegion, setSelectedRegion] = React.useState(0);

  const addNewRegion = () => {
    if (newRegion) {
      setRegions((prev) => [
        ...prev,
        {
          name: newRegion,
          subRegions: ['Todas'],
        },
      ]);
      setNewRegion('');
    }
  };

  const addNewSubRegion = () => {
    if (newSubRegion) {
      setRegions((prev) => {
        const newRegions = [...prev];
        newRegions[selectedRegion].subRegions.push(newSubRegion);
        return newRegions;
      });
      setNewSubRegion('');
    }
  };

  return (
    <Card>
      <FormHeader backBtnText="" title="Regiones" />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full flex flex-col">
            <h3 className="text-purple-300 font-semibold mx-auto">
              Agregar región
            </h3>
            <Input
              value={newRegion ?? ''}
              label="Nombre de la región"
              type="text"
              placeholder="Ingrese región"
              onChange={(e) => {
                setNewRegion(e.target.value);
              }}
            />
            <div className="mt-5 flex">
              <Button
                onClick={() => {
                  addNewRegion();
                }}
              >
                Agregar
              </Button>
            </div>
          </div>
          <div className="w-full flex flex-col">
            <h3 className="text-purple-300 font-semibold mx-auto">
              Agregar subregión
            </h3>
            <Select
              value={selectedRegion}
              label="Región que sea agregarle la subregión"
              onChange={(e) => {
                setSelectedRegion(Number(e.target.value));
              }}
            >
              {regions.map((region, index) => (
                <option key={index} value={index}>
                  {region.name}
                </option>
              ))}
            </Select>
            <Input
              value={newSubRegion ?? ''}
              label="Nombre de Subregión"
              type="text"
              placeholder="Ingrese región"
              onChange={(e) => {
                setNewSubRegion(e.target.value);
              }}
            />
            <div className="mt-5 flex">
              <Button
                onClick={() => {
                  addNewSubRegion();
                }}
              >
                Agregar
              </Button>
            </div>
          </div>
          <div className="w-full flex flex-col ">
            <h3 className="text-purple-300 font-semibold mx-auto">
              Regiones que cubre la empresa
            </h3>
            <RegionsList regions={regions} setRegions={setRegions} />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default RegionsInput;
